<template>
<div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/sale/exchanges">{{ $t('sale_exchange') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('create_new') }}</li>
        </ol>
    <div class="x_header">
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
            <i class="fa fa-arrow-circle-o-left"/> {{ $t('back') }}
        </button>
        <b-btn variant="outline-primary no-bor" size="sm" @click="onSave">
            <i class="fa fa-floppy-o" aria-hidden="true"/> {{$t('save')}}
        </b-btn>
    </div>
    <div class="x_body">
        <div class="card f_card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{ $t('customer') }}</label>
                            <div>
                                <CustomerDropdown @select="customerSelected" :value="header.CustomerName" />
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{ $t('stock') }}</label>
                            <div>
                                <select class="form-control form-control-sm" v-model="header.BranchId">
                                    <option v-for="ret in branchs" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{ $t('sale_reputation') }}</label>
                            <div>
                                <select class="form-control form-control-sm" v-model="header.EmployeeId">
                                    <option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ret.Code + ' : ' + ret.Name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{ $t('date') }}</label>
                            <div>
                                <input type="date" class="form-control form-control-sm" v-model="date" />
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{ $t('ref_num') }}</label>
                            <div>
                                <input type="text" class="form-control form-control-sm" v-model="header.RefNum" />
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="grid">
                            <thead>
                                <tr>
                                    <th style="width: 30px;"></th>
                                    <th>{{$t('item_name')}}</th>
                                    <th style="width: 120px;">{{$t('uom')}}</th>
                                    <th style="width: 120px;">{{$t('qty')}}</th>
                                    <th style="width: 120px;">{{$t('cost')}}</th>
                                    <th style="width: 120px;">{{$t('price_sale')}}</th>
                                    <th style="width: 120px;">{{$t('discount')}}($)</th>
                                    <th class="text-right" style="width: 120px;">{{$t('total_cost')}}</th>
                                    <th class="text-right" style="width: 120px;">{{$t('total_sale')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td style="width: 30px;">
                                        <button type="button" class="btn btn-danger btn-remove" @click="removeLine(index)">X</button>
                                    </td>
                                    <td>
                                        <AuthCompleted @select="itemSelect($event, ret)" :value="ret.ItemName"/>
                                    </td>
                                    <td>
                                        <UomDropdown :value="ret.UomName" :item_id="ret.ItemId" @select="uomChange($event, ret)"></UomDropdown>
                                    </td>
                                    <td class="text-center">
                                        <input type="number" class="form-control form-control-sm" v-model="ret.Quantity" @keypress="$isKeyNumber" @change="reCalculate" />
                                    </td>
                                    <td class="text-right">
                                        <input type="number" class="form-control form-control-sm" v-model="ret.Cost" @keypress="$isKeyNumber" @change="reCalculate" />
                                    </td>
                                    <td class="text-right">
                                        <input type="number" class="form-control form-control-sm" v-model="ret.SalePrice" @keypress="$isKeyNumber" @change="reCalculate" />
                                    </td>
                                    <td class="text-right">
                                        <input type="number" class="form-control form-control-sm" v-model="ret.Discount" @keypress="$isKeyNumber" @change="reCalculate" />
                                    </td>
                                    <td class="text-right">
                                        <input type="text" class="form-control form-control-sm text-right" :value="$money(ret.TotalCost)" readonly/>
                                    </td>
                                    <td class="text-right">
                                        <input type="text" class="form-control form-control-sm text-right" :value="$money(ret.SubTotal)" readonly/>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th rowspan="3" style="width: 30px;"></th>
                                    <th colspan="2" rowspan="3" style="vertical-align:top;"><button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="addLine"><i class="fa fa-plus"/> {{ $t('add_line') }}</button></th>
                                    <th colspan="5" class="text-right">{{$t('grand_total')}}</th>
                                    <th class="text-right">{{$money(header.TotalAmount)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="5" class="text-right">{{$t('discount')}}</th>
                                    <th class="text-right">{{$money(header.Discount)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="5" class="text-right">{{$t('paid_amount')}}</th>
                                    <th class="text-right">{{$money(header.PaidAmount)}}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="label-control blue">{{$t('remark')}}</label>
                            <div>
                                <textarea class="form-control form-control-sm" v-model="header.Remark"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import { AuthCompleted } from '../Item';
    import UomDropdown from '../UOM/Dropdown';
    import { CustomerDropdown } from '../Customer';
    export default {
        components: {
            AuthCompleted,
            UomDropdown,
            CustomerDropdown
        },
        data: function(){
            return {
                header: {
                    CustomerId: '',
                    CustomerName: '',
                    Discount: 0,
                    Deposit: 0,
                    TotalAmount: 0,
                    PaidAmount: 0,
                    Contact: '',
                    Num: ''
                },
                lines: [{
                    Checked: false,
                    ItemId: '',
                    ItemName: '',
                    UomId: '',
                    UomName: '',
                    Quantity: 1,
                    NoneQuantity: 0,
                    Cost: 0,
                    SalePrice: 0,
                    Discount: 0,
                    SubTotal: 0,
                    TotalCost: 0
                }],
                date: this.$now().format('YYYY-MM-DD'),
                actionLink: 'sale/exchange/save',
                branchs: [],
                employees: []
            }
        },
        created: async function(){
            let id = this.$route.params.id;
            let loading = this.$loading.show();
            await this.getEmployee();
            await this.branchList();
            if(id !== undefined && id != null && id !== ''){
                this.$api().post('sale/exchange/find', { Id: id }).then(res => {
                    var data = res.data.Json;
                    this.header = data.Header;
                    this.lines = data.Lines;
                    this.date = this.$format(this.header.Date, 'YYYY-MM-DD');
                }).finally(function() { loading.hide(); });
            }else{
                loading.hide();
            }
        },
        methods: {
            async branchList(){
                let res = await this.$api().post('branch/list', { Limit: 0 });
                if(this.$isValid(res)){
                    this.branchs = res.data.Data;
                }
            },
            async getEmployee(){
                let res = await this.$api().post('employee/select');
                if(this.$isValid(res)){
                    this.employees = res.data.Json.Employees;
                }
            },
            onSave(){
                const loading = this.$loading.show();
                this.header.Date = this.date;
                const req = {
                    Header: this.header,
                    Lines: this.lines
                };
                this.$api().post(this.actionLink, req).then(res => {
                    if(this.$isValid(res)){this.$router.push('/sale/exchanges');}
                }).finally(function() { loading.hide(); });
            },
            customerSelected(evt){
                this.header.CustomerId = evt.Id;
                this.header.CustomerName = evt.Name;
            },
            reCalculate(){
                let grand = 0;
                let discount = 0;
                this.lines.map(item => {
                    let newcost = item.SalePrice - item.Discount;
                    item.SubTotal = (item.Quantity * newcost);
                    grand += (item.SalePrice * item.Quantity);
                    discount += item.Quantity * item.Discount;
                    item.TotalCost = item.Quantity * item.Cost;
                });
                this.header.TotalAmount = grand;
                this.header.Discount = discount;
                this.header.PaidAmount = grand - Number(this.header.Discount);
            },
            addLine(){
                this.lines.push({
                    Checked: false,
                    ItemName: '',
                    Quantity: 1,
                    UomName: '',
                    UomId: '',
                    Cost: 0,
                    Discount: 0,
                    SubTotal: 0
                });
            },
            itemSelect(evt, line){
                line.ItemId = evt.Id;
                line.ItemName = evt.Name;
                line.Cost = evt.Cost;
                line.SalePrice = evt.Price;
                line.UomId = evt.UomId;
                line.UomName = evt.UomName;
                this.reCalculate();
            },
            removeLine(index){
                this.lines.splice(index, 1);
                this.reCalculate();
            },
            uomChange(e, line){
                line.UomId = e.UomId;
                line.UomName = e.UomName;
            },
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
    .none-left{
        border-left: none;
    }
</style>
